import React, { Component } from 'react';
import cx from 'classnames';
import TranslatedCopy from '../../intl/translated-copy';

class ErrorBarIcon extends Component {
  constructor() {
    super();
  }

  componentDidMount() {
    this.timeOutBanner();
  }

  componentWillUnmount() {
    clearTimeout(this.timeOutBanner());
  }

  render() {
    const {
      copyMessage,
      isSuccess,
    } = this.props;

    const ErrorBarIconClasses = cx({
      'ErrorBarIcon': true,
      'ErrorBarIcon-success': isSuccess,
      'ErrorBarIcon-fail': !isSuccess,
    });

    return (
      <div className={ ErrorBarIconClasses }>
        <div className='ErrorBarIcon-content'>
          { isSuccess ?
            <span className='Icon Icon--check' /> :
            <span className='Icon Icon--x' />
          }
          <TranslatedCopy copyID={ copyMessage } />
        </div>
        <button
          className='ErrorBarIcon-close Icon Icon--xThin'
          onClick={ () => this.closeErrorBanner() } 
        />
      </div>
    );
  }

  timeOutBanner = () =>  {
    setTimeout(() => {
      this.closeErrorBanner();
    }, 3000);
  }

  closeErrorBanner = () => {
    const { onClose } = this.props;
    
    onClose();
  }
}

export default ErrorBarIcon;
